import { Card } from "../../../components/Card";
import { Box, Flex, Heading, SkeletonText, Text, useToast } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import * as React from "react";
import { useGetSuppliersSpendsByLocation } from "../../../hooks/query/reports";
import { worldCountries } from "../helpers";
import { CURRENCY_SYMBOLS, numberFormatter, showErrorToast } from "../../../utils";
import { useState } from "react";

function TopTenLocations({ filterCategory }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "supplierAdminDashboard"
  });
  const toast = useToast();
  const [locationsData, setLocationsData] = useState([]);

  const {
    isFetching: isLocationsDataFetching
  } = useGetSuppliersSpendsByLocation({ year: 2023, categoryId: filterCategory }, {
    onSuccess: (data) => {
      if (data && Object.keys(data)?.length > 0) {
        const newLocationsData = Object.keys(data)
          .map(country => {
            return {
              id: worldCountries.find(obj => obj.properties.name.toLowerCase() === country.toLowerCase())?.id ?? country,
              country: country,
              value: data[country].reduce((acc, o) => acc + Number(o.totalAmount), 0) ?? 0,
              suppliers: data[country]
            };
          })
          .sort((a, b) => b.value - a.value);
        setLocationsData(newLocationsData.length > 10 ? newLocationsData.slice(0, 10) : newLocationsData);
      }
    },
    onError: err => showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message),
    cacheTime: 0
  });

  return (
    <Card padding={5} height="100%">
      {isLocationsDataFetching ?
        <SkeletonText mt="4" noOfLines={5} spacing="4" skeletonHeight="2" /> :
        <Flex flexFlow={"column"} gap={8}>
          <Heading as="h2" size="md">
            {t("topTenLocationsHeader")}
          </Heading>

          <Flex gap={1} justifyContent="space-between">
            <Box>
              {locationsData.map((el, index) => {
                return index < 5 ? <Text key={el.id} fontSize={"lg"}>
                  {index + 1}. {el.country} - {CURRENCY_SYMBOLS.GBP}{numberFormatter(el.value, 0)}
                </Text> : null;
              })}
            </Box>
            <Box>
              {locationsData.map((el, index) => {
                return index >= 5 ? <Text key={el.id} fontSize={"lg"}>
                  {index + 1}. {el.country} - {CURRENCY_SYMBOLS.GBP}{numberFormatter(el.value, 0)}
                </Text> : null;
              })}
            </Box>
          </Flex>
        </Flex>
      }
    </Card>
  );
}

export default TopTenLocations;